import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { SubNavVerticalSharedComponent } from './sub.nav.vertical.component';
import { IconSharedModule } from '../../atoms/icon/icon.module';

@NgModule({
    declarations: [
        SubNavVerticalSharedComponent
    ],
    imports: [
        CommonModule,
        IconSharedModule,
        RouterModule.forChild([])
    ],
    exports: [
        SubNavVerticalSharedComponent
    ]
})

export class SubNavVerticalSharedModule {}
